import { BottomSheetStackApi } from "@/components/BottomSheet";
import { SheetsType } from "../types/sheets.type";
import { SheetsEnum } from "../enums/sheets.enum";
import { SwitchSheetsLeadIconResult } from "../types/switch-sheets-lead-icons";
import { OctagonX } from "lucide-react";
import tw from "twin.macro";

const WarningIcon = tw.span`text-2xl font-medium`;

export function switchSheetsLeadIcons({
  sheet,
}: {
  sheet: BottomSheetStackApi<SheetsType>;
}): SwitchSheetsLeadIconResult {
  switch (sheet.visibleView?.id) {
    case SheetsEnum.AREA_LOCK:
      return {
        hasIcon: true,
        icon: () => <WarningIcon>⚠️</WarningIcon>,
      };
    case SheetsEnum.EMERGENCY_STOP:
      return {
        hasIcon: true,
        icon: () => <OctagonX tw="h-6 w-6 text-modules-redBase" />,
      };
    default:
      return { hasIcon: false };
  }
}
